import { Tooltip } from '@mui/material'
import { memo, useState } from 'react'
import { ArchivedIcon, AudioColorIcon, FaceBookIcon, FileActiveIcon, GoogleBusinessIcon, ImageColorIcon, InstaConversationCardIcon, LiveChatBlackandWhiteSmallIcon, LiveChatIcon, MarkasReadIcon, MarkasUnreadIcon, SettingsHorizIcon, TicketHighIcon, TicketLowIcon, TicketMediumIcon, TicketingStatusClosedIcon, TicketingStatusFollowingIcon, TicketingStatusOpenIcon, TrashIcon, UnArchivedIcon, VideoColorIcon, WatsappConversationCardIcon } from '../../icon'
import { MediaType, MessageType } from '../../models/media.models'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { LoadConnectMessages, UpdateContactTypes } from '../../actions'
import setToast from '../../helpers/toaster.helper'
import { mapToContactType } from '../../models/conversations'
import { ChannelUserModel } from '../../models/users.model'
import * as selector from "../../selectors/selectors"
import { MessageService } from '../../services/MessageService'
import { SettingsService } from '../../services/SettingsService'
import { UtilityService } from '../../services/UtilityService'
import { AppRoutes } from '../routes/route.path'
import Avatar from '../shared/avatar.component'
import ConfirmDialog from "../shared/confirm-dialog.component"
import { ActionLabels, ToasterTexts, appNote, buttonLabels } from '../shared/constants'
import { ChannelConversationStatus, ChannelType } from '../../models/conversations'
import { MenuItemRender } from '../shared/menu-item-render'
import { ToasterType } from '../shared/toaster/toaster.model'
import { ChannelConversationService } from '../../services/channels/ChannelConversationService'
import { ChanneTicketingPriority, ChanneTicketingStatus, ChannelAccountModel, ChannelAccountStatus } from '../../models/channels/channels.model'
import { ChannelUserService } from '../../services/ChannelUserService'



interface Props {
    data: any;
    style: any;
    index: number,
    onClick: () => void;
}

const ConversationCards = (props: Props) => {
    const user = ChannelUserService.getCurrentUserFromLocalStorage()

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const ChannelUsers: ChannelUserModel[] = useSelector(selector.ChannelUsers)

    const { data, style, index, onClick } = props
    const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const handleCardClick = (e: any) => {
        e.stopPropagation();
        onClick()
    }

    const handelArchive = (phoneNumber: string, archived: boolean, groupChatId: string) => {
        ChannelConversationService.setArchiveChannelConversation(user.OrganizationID, data.ID, !archived, user.ID).then(res => {
            setToast(archived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
            LoadConnectMessages(dispatch, user.OrganizationID)
        }).catch(err => { })
    }

    const handelPin = (phoneNumber: string, pinned: boolean, groupChatId: string) => {
        let pinnedChat = groupChatId ? groupChatId : phoneNumber
        MessageService.setContactAsPinned(pinnedChat, !pinned).then(res => {
            setToast(pinned ? ToasterTexts.UNPIN_SUCCES : ToasterTexts.PIN_SUCCESS, ToasterType.SUCCESS)
            UpdateContactTypes(dispatch, res.map(mapToContactType));
        }, (error) => {
            if (error?.response?.status === 400) {
                if (error?.response?.data?.code === SettingsService.Pinned_Contacts_Code) {
                    setToast(ToasterTexts.MAXIMUM_PINNED_CONV.replace("<count>", error?.response?.data?.value), ToasterType.DANGER);
                }
                else if (error?.response?.data?.message) {
                    setToast(error?.response?.data?.message, ToasterType.DANGER);
                }
            }
        });
    }

    const closeDeleteHistoryDialog = (isConfim: boolean, event?: any) => {
        event.stopPropagation();
        if (isConfim) {
            ChannelConversationService.deleteChannelConversation(user.OrganizationID, data.ID)
                .then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                    LoadConnectMessages(dispatch, user.OrganizationID)
                    navigate(AppRoutes.CONVERSATIONS)
                }).catch((er) => {
                    navigate(AppRoutes.CONVERSATIONS)
                })
        }
        else {
            setShowDeleteHistoryDialog(false)
        }
    }

    const handelMarkAsRead = (event?: any) => {
        if (data.UnReadCount > 0) {
            ChannelConversationService.readChannelConversation(user.OrganizationID, data.ID).then((res) => {
                setToast(ToasterTexts.MARK_AS_READ_SUCCESS, ToasterType.SUCCESS)
            }).catch(err => { })
        }
        else {
            ChannelConversationService.unReadChannelConversation(user.OrganizationID, data.ID).then((res) => {
                setToast(ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            }).catch(err => { })
        }
    }

    const optionData =
        [{
            Name: data.IsArchived ? ActionLabels.UNARCHIVE : ActionLabels.ARCHIVE,
            Icon: data.IsArchived ? UnArchivedIcon : ArchivedIcon,
            OnClick: () => handelArchive(data.PhoneNumber, data.IsArchived, data.GroupChat?.ID),
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            OnClick: () => setShowDeleteHistoryDialog(true),
        },
        {
            Name: (data.UnReadCount) > 0 ? ActionLabels.MARK_AS_READ : ActionLabels.MARK_AS_UNREAD,
            Icon: (data.UnReadCount) > 0 ? MarkasReadIcon : MarkasUnreadIcon,
            OnClick: (e) => handelMarkAsRead(e),
        },
        ]

    const getMultiMediaIcon = (mediaType) => {
        switch (mediaType) {
            case MessageType.IMAGE:
                return <ImageColorIcon className="mr-1 w-2 h-2" />
            case MessageType.VIDEO:
                return <VideoColorIcon className="mr-1 w-2 h-2" />
            case MessageType.AUDIO:
                return <AudioColorIcon className="mr-1 w-2 h-2" />
            case MessageType.FILE:
                return <FileActiveIcon className="mr-1 w-2 h-2" />
            case MessageType.TEXT:
                return
            default:
                return
        }
    }

    const getMediaComponent = (mediatype: string, Message: string) => {
        if (mediatype != (null) && mediatype != "text") {
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                    return MessageType.IMAGE
                case MediaType.VIDEO:
                    return MessageType.VIDEO
                case MediaType.AUDIO:
                    return MessageType.AUDIO
                default:
                    return MessageType.FILE
            }
        }
        else {
            return UtilityService.trimMessage(Message, 24)
        }
    }

    const currentUser = ChannelUserService.getCurrentUserFromLocalStorage();

    const trimMessage = (message: string, chars: number) => {
        const newLineIndex = message?.indexOf("\n")
        if (newLineIndex !== -1) {
            message = message?.slice(0, newLineIndex)
        }
        return !!message ? message.slice(0, chars) + (message.length > chars ? "..." : "") : "";
    }

    return (
        <div style={style} key={index} onClick={handleCardClick} id={index.toString()} className='d-flex align-center'>
            <span className='d-flex w-p-100 align-center h-8' key={data.ID + data.PhoneNumber}>
                <span className={`ml-1 h-p-70 ${(Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DELETED) ? "conv-card unsubscribed" : (data.Status === ChannelConversationStatus.CONVERSATION_WINDOW_EXPIRED || data.Status === ChannelConversationStatus.INACTIVE || Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED || Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY || data.Ticket?.Status === ChanneTicketingStatus.Closed) ? " conv-card warning" : "conv-card default"}`} />
                <div className={`d-flex w-p-100 h-p-100 highlight-conv-card-hover mr-1 br-1 c-pointer p-relative conv-card-border ${data?.IsActive ? "bg-color-con-card-active" : ""}`}>
                    <div className={`mr-1 my-auto`}>
                        <div className="d-flex mr-1 ml-1 p-relative my-auto">
                            <Avatar Name={data.Name} ImgSrc={data.ProfilePicLink && data?.ProfilePicLink} Index={index} Size={38} className='p-relative'></Avatar>
                            <div className={`p-absolute t-3 l-3 min-w-2 min-h-2 br-p-50 d-flex align-center`}>
                                {(Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DELETED || Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED || Channels?.find(x => x.ID === props.data?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ? <LiveChatBlackandWhiteSmallIcon width={16} height={16} /> : data.Type === ChannelType.FACEBOOK ? <FaceBookIcon /> : data.Type === ChannelType.INSTAGRAM ? <InstaConversationCardIcon className='w-2 h-2 br-p-50' /> : data.Type === ChannelType.LIVE_CHAT ? <LiveChatIcon width={16} height={16} /> : data.Type === ChannelType.WHATSAPP ? <WatsappConversationCardIcon className={"w-2 h-2"} /> : <GoogleBusinessIcon className={"w-3 h-3"} />}
                            </div>
                            {data.UnReadCount > 0 &&
                                <div className={`w-2 h-2 h6-footnote conv-unread-badge d-flex align-center justify-center b-none p-absolute t-0 l-0 br-p-50`}>
                                    {data.UnReadCount}
                                </div>
                            }
                        </div>
                    </div>
                    <div className='d-flex flex-direction w-p-100 mr-1 my-auto'>
                        <div className='d-flex justify-between'>
                            <span className={`${IsMobileDevice ? "h4-medium" : "h4-regular"}`}>
                                <div className='ph-no-capture'>
                                    {UtilityService.trimMessage(data.Type !== ChannelType.LIVE_CHAT ? data?.FirstName + ' ' + data?.LastName : data.Name, 24)}
                                </div>
                            </span>
                            <span className='h5-regular color-conv-date d-flex align-center'>
                                <div className={`${IsMobileDevice ? "h6-medium" : "footnote-semibold"} color-conv-card-title d-flex align-center`}>
                                    {
                                        props.data.Ticket.Priority === ChanneTicketingPriority.Low ? <Tooltip title="Low" placement="top"><TicketLowIcon className='' /></Tooltip>
                                            : props.data.Ticket.Priority === ChanneTicketingPriority.Medium ? <Tooltip title="Medium" placement="top"><TicketMediumIcon className='' /></Tooltip>
                                                : <Tooltip title="High" placement="top"><TicketHighIcon className='' /></Tooltip>
                                    }
                                    {
                                        props.data.Ticket.Status === ChanneTicketingStatus.Open ?
                                            <Tooltip title="Open" placement="top"><TicketingStatusOpenIcon className='mr-1 min-w-2 min-h-2' /></Tooltip>
                                            : props.data.Ticket.Status === ChanneTicketingStatus.Following ? <Tooltip title="Following" placement="top"><TicketingStatusFollowingIcon className='mr-1 min-w-2 min-h-2' /></Tooltip>
                                                : <Tooltip title="Close" placement="top"><TicketingStatusClosedIcon className='mr-1 min-w-2 min-h-2' /></Tooltip>
                                    }
                                </div>
                                {UtilityService.displayTime(data.MessageDateTime?.replace(" +0000 UTC", "Z") || data.CreatedAt?.replace(" +0000 UTC", "Z"))}
                            </span>
                        </div>
                        <div className={`d-flex justify-between`}>
                            <span className={`${IsMobileDevice ? "h4-regular" : "h5-medium"} color-conv-subtitle my-auto`}>
                                {!!data.TypingBy ?
                                    <div className='color-primary-light'>
                                        {data.TypingBy === currentUser.FullName ? "you are" : data.TypingBy + " is "} typing…
                                    </div> :
                                    <div className={`ph-no-capture ${data.UnReadCount > 0 ? "color-unread-message" : ""}`}>
                                        {getMultiMediaIcon(data?.MessageType)}
                                        {getMediaComponent(data.MessageType, data.Message)}
                                    </div>
                                }
                            </span>
                            <span className='d-flex my-auto justify-center align-center'>
                                {!!data.IsArchived &&
                                    <ArchivedIcon className=" w-2 h-2 mr-1" />}
                                <MenuItemRender HorizantelIcon={true} ClassName={"d-hover opacity-2"} MenuData={optionData} Data={data} MeetBallIcon={SettingsHorizIcon} />
                            </span>
                        </div>
                    </div>
                </div>
            </span>
            {showDeleteHistoryDialog &&
                <ConfirmDialog
                    onClose={closeDeleteHistoryDialog}
                    Show={showDeleteHistoryDialog}
                    Text={appNote.CONVERSATION_DELETE}
                    ButtonName={buttonLabels.DELETE}
                    Loading={isLoading}
                />
            }
        </div >
    )
}


export default memo(ConversationCards)